export default function formatNumber(number) {
  return new Intl.NumberFormat('zh-TW').format(number)
}
